// extracted by mini-css-extract-plugin
export default {"formWrapper":"Register_formWrapper__Qb-Xp","title":"Register_title__bifDR","form":"Register_form__ZCdyW","btns":"Register_btns__kqmcD"};